const EVENT_NAME_LOCATION_CHANGE = 'onLocationChange';

export {
  EVENT_NAME_LOCATION_CHANGE
};
